import { Button, VbzInputText } from '@smiles/voebiz-ui-kit';
import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'components/Tooltip';
import { postFormIndividual } from '../../services/services';

import Loader from '../Loader';

interface Props {
  handleBackButtonClick(): void;
  memberName: string;
  cpfValue: string;
  setCpfValue: React.Dispatch<React.SetStateAction<string>>;
  milesRange?: any;
  modalType?: 'team' | 'clients' | 'default';
  setErrorTypeIndividual: React.Dispatch<React.SetStateAction<string>>;
  setShowErrorModalIndividual: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccessModalIndividual: React.Dispatch<React.SetStateAction<boolean>>;
  setShowTransactionFormIndividual: React.Dispatch<React.SetStateAction<boolean>>;
}

const IncludeBeneficiaryForm: React.FC<Props> = ({
  handleBackButtonClick,
  memberName,
  cpfValue,
  setCpfValue,
  milesRange,
  modalType,
  setErrorTypeIndividual,
  setShowErrorModalIndividual,
  setShowSuccessModalIndividual,
  setShowTransactionFormIndividual,
}) => {
  const { t } = useTranslation(['includeTeam', 'summary', 'modalInclude']);

  const [campaingName, setCampaingName] = useState('');
  const [milesValue, setMilesValue] = useState('');
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isButtonDisabled = !memberName || !cpfValue || !campaingName || !milesValue || error;

  const handleMilesValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setMilesValue(inputValue);
    if (milesRange && (Number(inputValue) > milesRange.maxMiles || Number(inputValue) < milesRange.minMiles)) {
      setError(true);
    } else {
      setError(false);
    }
  };
  const handleCampaingNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setCampaingName(value);
  };
  const handleKeyDownNumber = (e: React.KeyboardEvent) => {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
    if (!(e.key >= '0' && e.key <= '9') && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  function formatMiles(value: string) {
    const numeric = value.replace(/\D/g, '');
    return numeric.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const handleSendTransaction = () => {
    const isClient = modalType === 'clients';
    setIsLoading(true);
    postFormIndividual(cpfValue, milesValue, campaingName, isClient)
      .then((response) => {
        if (response.success) {
          setShowSuccessModalIndividual(true);
          setShowTransactionFormIndividual(false);
        } else if (response.errorCode === '02') {
          setErrorTypeIndividual('innactiveAccount');
          setShowErrorModalIndividual(true);
          setShowTransactionFormIndividual(false);
        } else {
          setErrorTypeIndividual('generalError');
          setShowErrorModalIndividual(true);
          setShowTransactionFormIndividual(false);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="include-one-form" data-testid="test-form">
      <VbzInputText value={memberName} textLabel="Nome completo" disabled />
      <VbzInputText
        value={formatMiles(milesValue)}
        alt="beneficiario-milhas"
        placeholder="0000"
        textLabel="Quantidade de milhas"
        inputMode="numeric"
        onKeyDown={handleKeyDownNumber}
        forceError={error}
        errorMessage={`Escolha um valor entre ${milesRange?.minMiles} e ${milesRange?.maxMiles}.`}
        onChange={(e) => handleMilesValueChange(e)}
      />
      <VbzInputText
        value={campaingName}
        onChange={(e) => handleCampaingNameChange(e)}
        placeholder="Exemplo: Meta batida Squad Rosa"
        textLabel={
          <>
            Nome da campanha
            <Tooltip content="Use esse campo para identificar os envios" direction="top">
              <div className="vbz-icon-beneficiaries-tooltip-icon" />
            </Tooltip>
          </>
        }
        id="campaing-name-input-one"
      />
      <div className="btn-wrapper-confirmation">
        <button className="back-text-btn" type="button" onClick={handleBackButtonClick} data-testid="back-button">
          {t('includeTeam:go_back')}
        </button>

        <Button disabled={isButtonDisabled} onClick={handleSendTransaction} className="ok-button orange">
          {isLoading ? <Loader small /> : 'Enviar pedido'}
        </Button>
      </div>
    </div>
  );
};

export default IncludeBeneficiaryForm;
